import React from 'react';
import { useUserInfo } from '../../context/UserInfo';
import { EmployeeCourses } from './EmployeeCourses/EmployeeCourses';

export const MeCourses: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { id } = useUserInfo();
  return <EmployeeCourses employeeId={id} gotoColumVisible={true} />;
};
